import { AchEnrollmentStatus } from '@ocx/graphql';

import type { SupportedAchStatus } from './spire.constants';

export const isSupportedAchStatus = (status: AchEnrollmentStatus | null): status is SupportedAchStatus => {
  return (
    status === AchEnrollmentStatus.Active ||
    status === AchEnrollmentStatus.PendingEnrollment ||
    status === AchEnrollmentStatus.Rejected
  );
};
